// SUMMARY: Product feature flags. Flip a flag here to enable/disable a capability across the whole app
// without deleting its implementation — the code stays in place for a later re-enable.

// Image generation (in-chat "/image" + the public /v1/images API) is temporarily disabled. The pipeline,
// models, usage tracking and admin analytics code all remain; this flag just removes it from every
// user-facing surface (chat, plans, landing, docs, dashboard limits, flow graph). Set to `true` to restore.
export const IMAGE_GENERATION_ENABLED = false

// On-demand PDF document generation in chat ("create a PDF report about X", "/pdf ..."). When off, every
// message is treated as a normal text/search turn. The pipeline (intent, generation, PDF render, storage,
// download route, usage tracking) all remain in place; this flag just gates the chat-route branch.
export const DOCUMENT_GENERATION_ENABLED = true

// Project workspaces (topic-scoped chats + RAG context files + tables/calendar/todos/notes with in-chat
// AI actions). When off, the sidebar entry, routes and chat-route project branches are all hidden while
// the implementation stays in place.
export const PROJECTS_ENABLED = true

// Full-data table analysis: when a spreadsheet (xlsx/csv) is attached and the user asks to work on it, the
// turn re-reads the FULL persisted workbook and answers by running model-written JS over ALL rows in the
// isolated sandbox (not the truncated text view), and can return a downloadable modified file. Depends on the
// isolated-vm sandbox (the analyze turn makes model-written code the primary table interface), so it must
// stay OFF on any runtime where that boundary is not in place.
export const TABLE_ANALYSIS_ENABLED = true
